import PromoShopPromo from "./large/legacy/promo_shoppromo";
import Cinema from "./small/legacy/cinema";
import Carousel from "./legacy_carousel/carousel";


/*🤫*/

export function initCarouselForLargeShopPromosLegacy(){
    if (window.o_promo_shoppromo_legacy === null || window.o_promo_shoppromo_legacy === undefined) {
        window.o_promo_shoppromo_legacy = new PromoShopPromo();
    }
    const largeContainers = document.getElementsByClassName('promo_shoppromo-large--container');
    const promoShopPromo = window.o_promo_shoppromo_legacy;

    /*🤫*/
    [].forEach.call(largeContainers, (largeContainerDom : Element) => {
        if (largeContainerDom.getAttribute("data-isslidingcinemaenabled") === "false") {
            largeContainerDom.classList.add('promo_shoppromo-large--visible');
            PromoShopPromo.loadImages(largeContainerDom);
        }

        if (largeContainerDom.getAttribute("data-tracked") !== "true") {
            largeContainerDom.setAttribute("data-tracked", "true");
            promoShopPromo.trackInitialViewLargeShopPromo(largeContainerDom);
        }

        const itemContainer = largeContainerDom.querySelector('.promo_shoppromo-large--item-container');
        if (itemContainer != null) {
            if (largeContainerDom.getAttribute("data-initialized") !== "true") {
                largeContainerDom.setAttribute("data-initialized", "true");

                const isCarousel = itemContainer.classList.contains("promo_shoppromo-large--item-scroll-container");
                if (isCarousel) {
                    if (!window.o_promo_carousels) {
                        window.o_promo_carousels = [];
                    }
                    window.o_promo_carousels.push(new Carousel(largeContainerDom));
                }
            }
        }
    });
}

export function initCinemasForSmallShopPromosLegacy() {
    const config = {
        containerSelector: '.promo_shoppromo-small--tile-container',
        tileSelector: '.promo_shoppromo-small--tile',
        buttonLeftSelector: '.promo_shoppromo-small--cinema-button-left',
        buttonRightSelector: '.promo_shoppromo-small--cinema-button-right',
        buttonHideClass: 'promo_shoppromo-small--cinema-button-hide',
        tilePaddingRight: 8
    };

    const cinemaDomList = document.querySelectorAll(".promo_shoppromo-small--cinema-container");
    [].forEach.call(cinemaDomList, (cinemaDom: Element) => {
        if (cinemaDom.getAttribute("data-initialized") !== "true") {
            cinemaDom.setAttribute("data-initialized", "true");
            new Cinema(cinemaDom, config);
        }
    });
}